var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.474 5.52393H16.168C12.05 5.52393 8.5 8.86193 8.5 12.9819V34.4079C8.5 38.7599 11.818 42.2299 16.168 42.2299H32.146C36.266 42.2299 39.604 38.5299 39.604 34.4079V16.0759L29.474 5.52393Z",
    stroke: "#ffbb00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9492 5.50049V11.3185C28.9492 14.1585 31.2472 16.4625 34.0852 16.4685C36.7192 16.4745 39.4132 16.4765 39.5952 16.4645",
    stroke: "#ffbb00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.82 21H13.94V28H15.24V25.98H16.82C18.66 25.98 19.8 25.03 19.8 23.49C19.8 21.94 18.66 21 16.82 21ZM16.76 24.88H15.24V22.1H16.76C17.9 22.1 18.49 22.61 18.49 23.49C18.49 24.37 17.9 24.88 16.76 24.88ZM21.0982 28H24.1582C26.4282 28 27.9782 26.6 27.9782 24.5C27.9782 22.4 26.4282 21 24.1582 21H21.0982V28ZM22.3982 26.9V22.1H24.0982C25.6582 22.1 26.6682 23.05 26.6682 24.5C26.6682 25.95 25.6582 26.9 24.0982 26.9H22.3982ZM34.4699 22.09V21H29.3599V28H30.6599V25.32H34.0399V24.22H30.6599V22.09H34.4699Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file-icon.913e010cda30b10da3a1895e72cefa42.svg";
export { ForwardRef as ReactComponent };